
<svelte:head>
    <link rel="stylesheet" href="/plyr/plyr.css" />
    <script src="/plyr/plyr.js"></script>
</svelte:head>

<div class="w-full h-full flex flex-col items-center justify-center fixed z-888 top-0 left-0 right-0 bottom-0" class:hidden={!$mediaDialog.isOpen}>
    <div class="w-full h-full bg-black/70 backdrop-blur-[30px] absolute z-1" aria-hidden="true" on:click={() => closeDialog()}></div>
    <div class="absolute top-[20px] left-[20px] z-[4] hidden max-mobile:block" aria-hidden="true" on:click={() => closeDialog()}>
        <CloseIcon />
    </div>
    <div class="h-[606px] bg-black relative z-[2] max-mobile:w-full max-mobile:h-full">
        <div class="w-[60px] h-[44px] absolute top-[16px] right-[16px] z-[10] cursor-pointer" aria-hidden="true" on:click={()=>openURL($mediaDialog.proxyFile)}>
            <DownloadVideoBtn />
        </div>
        {#if $mediaDialog.type === 'video'}
            <video id="player" playsinline autoplay muted loop data-poster="{$mediaDialog.thumb}" class="w-full h-full">
            </video>
        {:else}
            <img src={$mediaDialog.proxyFile} alt="" class="w-full h-full object-contain">
        {/if}
    </div>
</div>
<script lang="ts">
    import DownloadVideoBtn from '$components/icons/DownloadVideoBtn.svelte'
    import CloseIcon from '$components/icons/CloseIcon.svelte'
    import { openURL } from '$lib/download';  
    import { mediaDialog } from '$lib/state/omnibox';
    import { onMount, onDestroy } from 'svelte';
    
    // 为 Plyr 定义简单类型
    type PlyrInstance = {
        destroy: () => void;
        [key: string]: any;
    };
    
    let player: PlyrInstance | null = null;
    
    function closeDialog() {
        mediaDialog.update(state => ({...state, isOpen: false, type:undefined}));
        if (player) {
            player.destroy();
            player = null;
            const videoElement = document.getElementById('player') as any;
            videoElement.remove()
        }
    }
    
    function initPlayer() {
        if ($mediaDialog.type === 'video' && $mediaDialog.isOpen) {
            
            const videoElement = document.getElementById('player') as any;
            if (videoElement) {
                videoElement.src = $mediaDialog.url
                player = new (window as any).Plyr(videoElement, {
                    autoplay: true,
                    controls: [
                        'play-large', // The large play button in the center
                        'play', // Play/pause playback
                        'progress', // The progress bar and scrubber for playback and buffering
                        'duration', // The full duration of the media
                        'fullscreen', // Toggle fullscreen
                    ],
                    settings: ['speed'],
                    speed: {
                        selected: 1, // 默认速度
                        options: [0.75, 1, 1.5, 2], // 用户可以设置的速度选项
                    },
                    i18n: {
                        speed: 'speed', // 更改为中文的“速度”
                        normal: 'normal', // 更改为中文的“正常速度”
                    },
                })
            }
        }
    }
    
    
    $: if ($mediaDialog.isOpen && $mediaDialog.type === 'video') {
        // 使用 setTimeout 确保 DOM 已更新
        setTimeout(initPlayer, 0);
    }
    
    onDestroy(() => {
        if (player) {
            player.destroy();
            player = null;
        }
    });
</script>
<style>
    video {
        transform: translateZ(0);
        will-change: transform;
        z-index: 0;
        position: relative;
    }
    
    :global(.plyr--video) {
        width: 100%;
        height: 100%;
    }
    
    :global(.plyr__video-wrapper) {
        width: 100%;
        height: 100%;
    }
        
    :root {
        --plyr-color-main: #F84095;
    }
</style>
